import { useState, type FormEvent } from "react";

const comments = [
  {
    user: "时间线本尊",
    tone: "bg-primary-200 text-primary-900",
    text: "把顾言泽那条按时间排完，其实早年的回应和最近这次能对上，就是中间空了一段没人整理，档案里我补了占位。",
    tags: ["#顾言泽", "#逐条对照"],
    likes: 328,
    replies: 41,
  },
  {
    user: "吃瓜群众A",
    tone: "bg-secondary-200 text-secondary-900",
    text: "桃桃酱那个链接又上架了，这已经是第三次，先截图留证再看后面怎么解释，别急着下结论。",
    tags: ["#桃桃酱", "#留证"],
    likes: 216,
    replies: 28,
  },
  {
    user: "路人甲来啦",
    tone: "bg-accent-200 text-accent-900",
    text: "主播区的阿宁档案整理得挺细，来源都标了档，拿不准的也写了待证实，这种态度我认。",
    tags: ["#主播区", "#靠谱"],
    likes: 154,
    replies: 12,
  },
];

const pollOptions = [
  { label: "先看时间线，别急着给结论", votes: 3824, pct: 62 },
  { label: "先甩立场，细节再说", votes: 1488, pct: 24 },
  { label: "只看乐子，不下场", votes: 872, pct: 14 },
];

export default function Discussion() {
  const [text, setText] = useState("");
  const [posted, setPosted] = useState(false);

  const post = (e: FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    setPosted(true);
  };

  return (
    <section id="talk" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:py-14">
        <div className="text-center">
          <p className="mb-1 text-xs font-semibold tracking-widest text-primary-500">DISCUSS</p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            围观广场 · 对时间线的人都在这里
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-500">
            不吹不黑，先把事件捋清楚。你可以补时间、贴证据，也可以只是蹲一条更新。理性吃瓜，评论区见。
          </p>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-[1fr_340px]">
          {/* 讨论主列 */}
          <div>
            {/* 发言框 */}
            <form onSubmit={post} className="rounded-2xl border border-background-200 bg-background-50 p-4">
              <div className="flex items-start gap-3">
                <span className="font-heading flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                  我
                </span>
                <div className="flex-1">
                  <textarea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    maxLength={140}
                    placeholder="补充你看到的时间节点 / 贴证据 / 聊聊这瓜…"
                    className="min-h-[76px] w-full resize-none rounded-xl border border-background-200 bg-background-100/50 px-3 py-2.5 text-sm leading-6 text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-300"
                  />
                  {posted && (
                    <p className="mt-2 flex items-center gap-1.5 rounded-lg bg-secondary-100 px-3 py-2 text-xs text-secondary-800">
                      <i className="ri-checkbox-circle-line" />
                      发言已发出（演示页面，仅展示效果）——已帮你挂到对应人物话题下，@小编 会看到。
                    </p>
                  )}
                  <div className="mt-2 flex items-center justify-between">
                    <div className="flex items-center gap-1 text-foreground-400">
                      <button type="button" className="flex h-7 w-7 items-center justify-center rounded-full hover:bg-background-200 hover:text-foreground-700" aria-label="添加标签">
                        <i className="ri-hashtag" />
                      </button>
                      <button type="button" className="flex h-7 w-7 items-center justify-center rounded-full hover:bg-background-200 hover:text-foreground-700" aria-label="配图">
                        <i className="ri-image-add-line" />
                      </button>
                      <button type="button" className="flex h-7 w-7 items-center justify-center rounded-full hover:bg-background-200 hover:text-foreground-700" aria-label="位置">
                        <i className="ri-map-pin-line" />
                      </button>
                      <span className="ml-1 text-xs">{text.length}/140</span>
                    </div>
                    <button
                      type="submit"
                      className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                    >
                      发布到广场
                    </button>
                  </div>
                </div>
              </div>
            </form>

            {/* 热评列表 */}
            <div className="mt-4 space-y-3">
              {comments.map((c) => (
                <article key={c.user} className="flex gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
                  <span className={`font-heading flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold ${c.tone}`}>
                    {c.user.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900">{c.user}</span>
                      <span className="text-xs text-foreground-400">围观中</span>
                    </div>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{c.text}</p>
                    <div className="mt-2 flex flex-wrap gap-1.5">
                      {c.tags.map((tg) => (
                        <button key={tg} type="button" className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-primary-600 hover:text-primary-700">
                          {tg}
                        </button>
                      ))}
                    </div>
                    <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
                      <button type="button" className="flex items-center gap-1 transition-colors hover:text-primary-600">
                        <i className="ri-thumb-up-line" /> {c.likes}
                      </button>
                      <button type="button" className="flex items-center gap-1 transition-colors hover:text-primary-600">
                        <i className="ri-chat-3-line" /> {c.replies}
                      </button>
                      <button type="button" className="flex items-center gap-1 transition-colors hover:text-primary-600">
                        <i className="ri-share-forward-line" /> 转发
                      </button>
                      <span className="ml-auto hidden sm:inline">2 分钟前</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-3 text-center">
              <button
                type="button"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-5 py-2 text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                查看更多广场发言 <i className="ri-arrow-down-line" />
              </button>
            </div>
          </div>

          {/* 侧栏：投票 + 规范 */}
          <aside className="space-y-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                <i className="ri-bar-chart-grouped-line text-accent-600" /> 今天大家怎么看
              </h3>
              <p className="mt-1 text-xs text-foreground-400">围观同一事件，先站哪边？</p>
              <div className="mt-4 space-y-2.5">
                {pollOptions.map((o) => (
                  <button key={o.label} type="button" className="group relative block w-full overflow-hidden rounded-xl border border-background-200 text-left">
                    <span className="absolute inset-0 bg-secondary-100/0 transition-colors group-hover:bg-secondary-100/60" />
                    <span
                      className="absolute inset-y-0 left-0 bg-secondary-100"
                      style={{ width: `${o.pct}%` }}
                      aria-hidden
                    />
                    <span className="relative flex items-center justify-between px-3 py-2.5">
                      <span className="text-sm text-foreground-700">{o.label}</span>
                      <span className="text-xs font-semibold text-secondary-700">{o.pct}%</span>
                    </span>
                  </button>
                ))}
              </div>
              <p className="mt-3 text-center text-xs text-foreground-400">1.2w 人已投票 · 每小时刷新</p>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-100/70 p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                <i className="ri-voiceprint-line text-primary-500" /> 广场公约
              </h3>
              <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
                {["先摆时间线，再谈结论", "对事不对人，不做人身攻击", "贴证据请标来源与时间", "待证实内容别当实锤转发"].map((r) => (
                  <li key={r} className="flex items-start gap-2">
                    <i className="ri-check-line mt-0.5 text-accent-600" />
                    <span>{r}</span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}